export const IS_PROD = process.env.NODE_ENV === 'production';
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_STAGING = process.env.NODE_ENV === 'staging';
export const IS_TEST = process.env.NODE_ENV === 'test';
